import { Monitor, Moon, Sun, type LucideIcon } from 'lucide-react';
import { useTheme, type ThemePreference } from '../../lib/theme.ts';
import { cn } from '../../lib/cn.ts';
import { buttonTapped } from '../../lib/usage.ts';

const OPTIONS: Array<{ value: ThemePreference; label: string; icon: LucideIcon }> = [
  { value: 'system', label: 'System', icon: Monitor },
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
];

/** Three-way appearance choice, as a segmented control. */
export function ThemeSwitch({ className }: { className?: string }) {
  const { preference, setPreference } = useTheme();
  return (
    <div role="radiogroup" aria-label="Appearance" className={cn('grid grid-cols-3 gap-1 rounded-full bg-paper p-1', className)}>
      {OPTIONS.map(({ value, label, icon: Icon }) => {
        const selected = preference === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => {
              buttonTapped(`theme_${value}`);
              setPreference(value);
            }}
            className={cn(
              'flex h-8 items-center justify-center gap-1.5 rounded-full text-xs font-semibold transition-colors',
              selected ? 'bg-surface text-ink shadow-[0_1px_2px_rgba(0,0,0,0.12),0_0_0_1px_var(--line)]' : 'text-muted hover:text-ink',
            )}
          >
            <Icon className="h-3.5 w-3.5" aria-hidden />
            {label}
          </button>
        );
      })}
    </div>
  );
}
